document.addEventListener("DOMContentLoaded", function () {
  const attachmentsTrigger = document.querySelector('.js-contact-form-attachments-trigger');
  const attachmentsPreview = document.querySelector('.js-contact-form-attachments-preview');
  if (attachmentsTrigger && attachmentsPreview) {
    attachmentsTrigger.addEventListener('change', function () {
      if (this.files.length > 0) {
        attachmentsPreview.textContent = [...this.files].map(x => x.name).join(', ');
      } else {
        attachmentsPreview.textContent = attachmentsPreview.getAttribute('data-placeholder');
      }
    });
  }
});